export type CottageContact = {
  message: string
  traveler_email: string
  traveler_name: string
  traveler_phone: string
}

const CottageContactName = '_p-cottage-contact-dialog'
const CottageContactDays = 1

export const useCookiesRurality = () => {
  const runtimeConfig = useRuntimeConfig()

  const cookieParams = {
    domain: runtimeConfig.public.COOKIE_DOMAIN,
    path: '/',
  }

  function getCookieRurality(cookieName: string): any {
    const cookieInstance: any = useCookie(cookieName, {
      ...cookieParams,
      readonly: true,
    })

    return cookieInstance?.value
  }

  function setCookieRurality(data: any, cookieName: string, days: number) {
    const date = new Date()
    date.setTime(days * 24 * 60 * 60 * 1000 + date.getTime())

    const customCookieParams = {
      ...cookieParams,
      expires: date,
      encode: (value: any): string => {
        return JSON.stringify(value)
      },
    }

    const cookieInstance = useCookie(cookieName, customCookieParams)

    cookieInstance.value = data
  }

  function setCookieRuralityCottageContact(cottageContact: CottageContact) {
    setCookieRurality(cottageContact, CottageContactName, CottageContactDays)
  }

  function getCookieRuralityCottageContact(): CottageContact {
    const cookieInstance = getCookieRurality(CottageContactName)

    const item: CottageContact = {
      message: cookieInstance?.message || '',
      traveler_email: cookieInstance?.traveler_email || '',
      traveler_name: cookieInstance?.traveler_name || '',
      traveler_phone: cookieInstance?.traveler_phone || '',
    }

    return item
  }

  return {
    getCookieRurality,
    setCookieRurality,
    getCookieRuralityCottageContact,
    setCookieRuralityCottageContact,
  }
}
